// extracted by mini-css-extract-plugin
export default {"imageWrapper":"jH-z","hovered":"kH-z","hoverImage":"lH-z","mainImage":"mH-z","imageNoBackground":"nH-z","fullSizeImage":"oH-z"};